module.exports = __webpack_public_path__ + "static/media/Carlos Slim Helu.8352b3d1.jpg";